import * as PropTypes from 'prop-types'
import React from 'react'

const FontAwesomeIcon = (props) => {
  const style = {}
  if (props.size) {
    style.fontSize = `${props.size}px`
  }

  if (props.rotate) {
    style.transform = `rotate(${props.rotate}deg)`
  }

  const additionalClassName
    = props.className && props.className.trim().length
      ? ` ${props.className}`
      : ''

  return (
    <i
      title={props.title}
      className={`fa fa-${props.name}${additionalClassName}`}
      aria-hidden="true"
      style={style}
    />
  )
}

FontAwesomeIcon.defaultProps = {
  name: 'flag',
  size: null,
}

FontAwesomeIcon.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.number,
  rotate: PropTypes.number,
  title: PropTypes.string,
}

export { FontAwesomeIcon as default }
